<div class="container register">
    <div class="row">
        <div class="col-md-3 register-left">
            <!-- <img src="https://image.ibb.co/n7oTvU/logo_white.png" alt="" /> -->
            <svg xmlns="http://www.w3.org/2000/svg" width="40px" height="40px" fill="currentColor" class="bi bi-people-fill" viewBox="0 0 16 16">
                <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                <path fill-rule="evenodd" d="M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z"/>
                <path d="M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"/>
              </svg>
            <h3>Bienvenido</h3>
            <p>Si quieres empezar a disfrutar de los tours regístrate como usuario estándar.
                Si quieres ser creador de contenido y aportar tu granito de arena, regístrate como creador</p>

        </div>
        <div class="col-md-9 register-right">
            <ul class="nav nav-tabs nav-justified" id="myTab" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab"
                        aria-controls="home" aria-selected="true" (click)="tipoRegistro(profileTypes.Estandar)">Estándar</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab"
                        aria-controls="profile" aria-selected="false" (click)="tipoRegistro(profileTypes.Creador)">Creador</a>
                </li>
            </ul>
            <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" role="tabpanel" aria-labelledby="home-tab">
                    <h3 class="register-heading">{{tituloRegistro}}</h3>
                    <form class="create-form" [formGroup]="registerForm"
                        (ngSubmit)="onSubmit(registerForm.value)">
                        <div class="row register-form">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" formControlName="name"
                                        placeholder="Nombre *" value="" />
                                    <ng-container *ngFor="let validation of validation_messages.name">
                                        <div class="invalid-feedback"
                                            *ngIf="registerForm.get('name').hasError(validation.type) && (registerForm.get('name').dirty || registerForm.get('name').touched)">
                                            {{validation.message}}</div>
                                    </ng-container>
                                </div>
                                <div class="form-group">
                                    <input type="text" class="form-control" formControlName="lastname"
                                        placeholder="Apellidos *" value="" />
                                    <ng-container *ngFor="let validation of validation_messages.lastname">
                                        <div class="invalid-feedback"
                                            *ngIf="registerForm.get('lastname').hasError(validation.type) && (registerForm.get('lastname').dirty || registerForm.get('lastname').touched)">
                                            {{validation.message}}</div>
                                    </ng-container>
                                </div>                                
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="email" class="form-control" formControlName="email"
                                        placeholder="Email *" value="" />
                                    <ng-container *ngFor="let validation of validation_messages.email">
                                        <div class="invalid-feedback"
                                            *ngIf="registerForm.get('email').hasError(validation.type) && (registerForm.get('email').dirty || registerForm.get('email').touched)">
                                            {{validation.message}}</div>
                                    </ng-container>
                                </div>
                                <div class="form-group">
                                    <input type="password" class="form-control" formControlName="password"
                                        placeholder="Contraseña *" value="" />
                                    <ng-container *ngFor="let validation of validation_messages.password">
                                        <div class="invalid-feedback"
                                            *ngIf="registerForm.get('password').hasError(validation.type) && (registerForm.get('password').dirty || registerForm.get('password').touched)">
                                            {{validation.message}}</div>
                                    </ng-container>
                                </div>
                                <button type="submit" class="btnRegister" [disabled]="!registerForm.valid">Registrarse</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>